// extracted by mini-css-extract-plugin
module.exports = {"cardHeader":"header_cardHeader__3C0Lz","cardLogo":"header_cardLogo__1_lY3","cardEditIcon":"header_cardEditIcon__1wd5U"};